import { FunctionalComponent, h } from 'preact';
import { cleanProps } from '../../../utils';
import { withStyles } from '../../../style';
import * as styles from './Input.scss';
import { PromoCodeInputProps, PromoCodeInputState, EffectiveProps, InputElement } from './types';

export const PromoCodeInput: FunctionalComponent<PromoCodeInputProps & InputElement> = withStyles(styles)(
  (props: EffectiveProps) => {
    const { tx, state, label, errorText } = props;
    const cleanedProps = cleanProps(props, ['label', 'tx']);

    return (
      <div class={tx(`bw-input ${state || PromoCodeInputState.DEFAULT}`)}>
        <label class="block">
          <div class={tx('label font-heading-5 regular-type nordic-blue-900-text ms-xxsmall-b')}>{label}</div>
          <input {...cleanedProps} class={tx('focusInset ps-xxsmall font-body-1 fill')} type="text" />
        </label>
        <div class={tx('error-label font-body-1 error-900-text')}>{errorText}</div>
      </div>
    );
  }
);
